import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from "."
import { URI } from "../../constants/URI"
import { setSalesReps, setUsers } from "../slices/usersSlice"
import { store } from "../store"


export const getUsers = async (body) => {
    const res = await handlePostRequest(URI.users, body)
    if (res?.ack) {
        store.dispatch(setUsers(res?.users || []))
    }
    return res
}

export const getSalesReps = async () => {
    const res = await handleGetRequest(URI.sales_reps, null, {
        toast: false,
        loading: false
    })
    if (res?.ack) {
        store.dispatch(setSalesReps(res?.users || []))
    }
    return res
}

export const addUser = async (body) => {
    const res = await handlePostRequest(URI.user, body)
    return res
}

export const getUser = async (id) => {
    const res = await handleGetRequest(URI.user, null, {
        params: { id },
    })
    return res
}

export const updateUser = async (body) => {
    const res = await handlePutRequest(URI.user, body)
    return res
}

export const deleteUser = async (body) => {
    const res = await handleDeleteRequest(URI.user, body)
    if (res?.ack) getUsers()
    return res
}

export const getAssignUsersList = async (id) => {
    const res = await handleGetRequest(URI.assign_users, null, {
        params: { id },
    })
    return res
}

export const addAssignUser = async (body) => {
    const res = await handlePostRequest(URI.assigned_user, body)
    return res
}

export const getAssignedUsers = async (id) => {
    const res = await handleGetRequest(URI.assigned_users, null, {
        params: { id },
    })
    return res
}

export const deleteAssignedUser = async (body) => {
    const res = await handleDeleteRequest(URI.assigned_user, body)
    return res
}

export const addAssignCustomer = async (body) => {
    const res = await handlePostRequest(URI.assigned_customer, body)
    return res
}

export const getAssignedCustomers = async (id) => {
    const res = await handleGetRequest(URI.assigned_customers, null, {
        params: { id },
    })
    return res
}

export const deleteAssignedCustomer = async (body) => {
    const res = await handleDeleteRequest(URI.assigned_customer, body)
    return res
}

// Alternate Users APIs
export const addAlternateUser = async (body) => {
    const res = await handlePostRequest(URI.user_replacement, body)
    return res
}

export const getAlternateUsers = async (body) => {
    const res = await handlePostRequest(URI.user_replacements, body)
    return res
}

export const deleteAlternateUser = async (body) => {
    const res = await handleDeleteRequest(URI.user_replacement, body)
    return res
}

export const getCustomerReplacements = async (body) => {
    const res = await handlePostRequest(URI.customer_replacements, body)
    return res
}

export const assignCustomerReplacements = async (body) => {
    const res = await handlePostRequest(URI.assign_customer_replacements, body, { loading: false })
    return res
}

export const unassignCustomerReplacements = async (body) => {
    const res = await handleDeleteRequest(URI.customer_replacements, body)
    return res
}